/*global TTEnterprise TTEnterpriseTypeEnum */
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { v2Api } from 'moovila-common';
import validator from 'validator';
import cx from 'classnames';
import { SketchPicker } from 'react-color';

import { Dialog, QuestionBox } from 'moovila-common';

import CheckForDirtyUtility from '../../utilities/checkForDirty';

const enterpriseTypes = [
  {
    code: TTEnterpriseTypeEnum.ET_CONSUMER,
    name: 'Consumer',
  },
  {
    code: TTEnterpriseTypeEnum.ET_COMMERCIAL,
    name: 'Commercial',
  },
  {
    code: TTEnterpriseTypeEnum.ET_NON_PROFIT,
    name: 'Nonprofit',
  },
  {
    code: TTEnterpriseTypeEnum.ET_HIGHER_ED,
    name: 'Higher-ed',
  },
  {
    code: TTEnterpriseTypeEnum.ET_GOVERNMENT,
    name: 'Government',
  },
  {
    code: TTEnterpriseTypeEnum.ET_CUSTOM,
    name: 'Custom',
  },
];



const enterpriseLanguages = [
  {
    code: 'en-US',
    name: 'English',
  },
  {
    code: 'ja',
    name: '日本語',
  },
  {
    code: 'fr',
    name: 'Français',
  },
  {
    code: 'da',
    name: 'Dansk',
  },
  {
    code: 'nl',
    name: 'Nederlands',
  },
  {
    code: 'de',
    name: 'Deutsch',
  },
  {
    code: 'cs',
    name: 'Čeština'
  }
];


const enterpriseCountries = [
  {
    country: 'Australia',
    code: 'AU',
  },
  {
    country: 'Belgium',
    code: 'BE',
  },
  {
    country: 'Canada',
    code: 'CA',
  },
  {
    country: 'Czech Republic',
    code: 'CZ',
  },
  {
    country: 'Denmark',
    code: 'DK',
  },
  {
    country: 'France',
    code: 'FR',
  },
  {
    country: 'Germany',
    code: 'DE',
  },
  {
    country: 'Japan',
    code: 'JP',
  },
  {
    country: 'United Kingdom',
    code: 'GB',
  },
  {
    country: 'United States',
    code: 'US',
  },
];

const SSOProviderIDEnum = {
  SSO_LANDLOG: 0,
  SSO_SAML: 1,
}


const enterpriseModel = new TTEnterprise();

class AddEditEnterprise extends Component {
  constructor(props) {
    super(props);

    const freshState = {
      ...enterpriseModel,
      enterpriseColor: '#8b91ff',
      adminEmail: '',
      domainToWhitelist: '',
      domainToDelete: null,
      sessionTimeoutMinutes: '0',
      requireTerms: true,
      requireServiceAgreement: true,
      isSCF: true,
      pw_minLength: '7',
      pw_expirationMonths: '0',
      pw_attemptsBeforeLockout: '0',
      pw_historyReuseFrequency: '0',
      pw_enforceComplexity: false,
    };

    this.state = {
      ...freshState,
      redirect: false,
      showColorPicker: false,
      isAddingDomain: false,
      question: null,
      message: null,
      pw_loaded: false,
    }

    this.checkForDirty = CheckForDirtyUtility(freshState);

    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxToggle = this.handleCheckboxToggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.toggleColorPicker = this.toggleColorPicker.bind(this);
    this.handleColorPickerChange = this.handleColorPickerChange.bind(this);
    this.handleColorTextChange = this.handleColorTextChange.bind(this);
    this.handleColorTextClick = this.handleColorTextClick.bind(this);
    this.handleColorTextKeyDown = this.handleColorTextKeyDown.bind(this);
    this.addDomain = this.addDomain.bind(this);
    this.deleteDomain = this.deleteDomain.bind(this);
    this.resetDeleteDomain = this.resetDeleteDomain.bind(this);
    this.duplicateAdminAsPrimary = this.duplicateAdminAsPrimary.bind(this);
    this.clickOutsideColorPicker = this.clickOutsideColorPicker.bind(this);
    this.clickOnColorPicker = this.clickOnColorPicker.bind(this);
  }

  componentWillMount() {
    if (this.props.method === 'edit') {
      this.props.getEnterpriseInfo(this.props.enterpriseGUID);
      this.props.getEnterpriseRoles(this.props.enterpriseGUID);
    } else {
      this.props.getDefaultPasswordConfiguration();
    }
  }

  componentWillUnmount() {
    this.props.clearEnterpriseInfo();
  }

  componentWillReceiveProps(nextProps) {
    const detail = nextProps.enterpriseDetail;

    if (
      nextProps.method === 'edit' &&
      this.props.method !== nextProps.enterpriseGUID &&
      this.state.pw_loaded === false &&
      Object.keys(detail).filter(d => d !== '__Roles').length
    ) {
      const freshState = {
        enterpriseName: detail.enterpriseName,
        enterpriseTypeCode: detail.enterpriseTypeCode,
        enterpriseGUID: detail.enterpriseGUID,
        defaultRoleGUID: detail.defaultRoleGUID,
        isActive: detail.isActive,
        canUseBroadcast: detail.canUseBroadcast,
        secureImages: detail.secureImages,
        autoApprove: detail.autoApprove,
        canHaveExtendedTribes: detail.canHaveExtendedTribes,
        requireTerms: detail.requireTerms,
        requireServiceAgreement: detail.requireServiceAgreement,
        isSCF: detail.isSCF,
        sessionTimeoutMinutes: String(detail.sessionTimeoutMinutes),
        enterpriseColor: `#${detail.enterpriseColor}`,
        primaryContactName: detail.primaryContactName,
        primaryContactPhone: detail.primaryContactPhone,
        primaryContactEmail: detail.primaryContactEmail,
        secondaryContactName: detail.secondaryContactName,
        secondaryContactPhone: detail.secondaryContactPhone,
        secondaryContactEmail: detail.secondaryContactEmail,
        pw_minLength: String(detail.pw_minLength),
        pw_expirationMonths: String(detail.pw_expirationMonths),
        pw_attemptsBeforeLockout: String(detail.pw_attemptsBeforeLockout),
        pw_historyReuseFrequency: String(detail.pw_historyReuseFrequency),
        pw_enforceComplexity: detail.pw_enforceComplexity,
        pw_loaded: true,
        language: detail.language,
        countryISOCode: detail.countryISOCode,
        ssoProviderID: detail.ssoProviderID,
        currency: detail.currency
      };

      this.setState({
        ...freshState,
        entDetail: detail,
      });
      this.checkForDirty = CheckForDirtyUtility(freshState);
    }

    if (
      nextProps.method === 'add' &&
      nextProps.utilities.defaultPasswordConfiguration &&
      this.state.pw_loaded === false
    ) {
      this.setState({
        pw_minLength: String(nextProps.utilities.defaultPasswordConfiguration.pw_minLength),
        pw_expirationMonths: String(nextProps.utilities.defaultPasswordConfiguration.pw_expirationMonths),
        pw_attemptsBeforeLockout: String(nextProps.utilities.defaultPasswordConfiguration.pw_attemptsBeforeLockout),
        pw_historyReuseFrequency: String(nextProps.utilities.defaultPasswordConfiguration.pw_historyReuseFrequency),
        pw_enforceComplexity: nextProps.utilities.defaultPasswordConfiguration.pw_enforceComplexity,
        pw_loaded: true,
      });
    }
  }

  handleChange(e) {
    const name = e.target.name;
    let value = e.target.value || '';

    if (name === 'primaryContactPhone' || name === 'secondaryContactPhone') {
      if (value.length > 20) {
        value = this.state[name];
      }
    }
    this.setState({ [name]: value });
  }

  handleCheckboxToggle(e) {
    const name = e.target.name;
    this.setState({ [name]: !this.state[name] });
  }

  validate() {
    let message = '';
    if (!this.state.enterpriseName.trim().length) {
      message = 'Enterprise name is a required field';
    } else if (this.props.method === 'add' && !this.state.adminEmail.trim().length) {
      message = 'Please enter an admin email';
    } else if (this.props.method === 'add' && !validator.isEmail(this.state.adminEmail.trim())) {
      message = 'Please enter a valid admin email';
    } else if ((!this.state.countryISOCode || parseInt(this.state.countryISOCode, 10) === 0) && this.state.isSCF) {
      message = 'Please choose a country';
    } else if ((!this.state.language || parseInt(this.state.language, 10) === 0) && this.state.isSCF) {
      message = 'Please select a language';
    } else if (!this.state.sessionTimeoutMinutes.trim().length) {
      message = 'Please enter a session timeout';
    } else if (this.state.sessionTimeoutMinutes.trim() > 43200) {
      message = 'Minutes of activity must be less than or equal to 43200.';
    } else if (!validator.isInt(this.state.sessionTimeoutMinutes.trim(), { min: 0 })) {
      message = 'Session timeout must be 0 or a positive integer';
    } else if (!this.state.enterpriseTypeCode || parseInt(this.state.enterpriseTypeCode, 10) === 0) {
      message = 'Please choose an enterprise type';
    } else if (this.props.method === 'edit' && !this.state.defaultRoleGUID) {
      message = 'Please choose a default role';
    } else if (!this.state.enterpriseColor.length) {
      message = 'Please provide a color';
    } else if (!validator.isHexColor(this.state.enterpriseColor)) {
      message = 'Please provide a valid hex color';
    } else if (this.state.primaryContactEmail.length && !validator.isEmail(this.state.primaryContactEmail)) {
      message = 'Please check the formatting of the primary contact email';
    } else if (this.state.secondaryContactEmail.length && !validator.isEmail(this.state.secondaryContactEmail)) {
      message = 'Please check the formatting of the secondary contact email';
    } else if (!validator.isInt(this.state.pw_minLength, { min: 3 })) {
      message = 'Minumun password length is 3';
    } else if (!validator.isInt(this.state.pw_minLength, { max: 100 })) {
      message = 'Minumun password length must be 100 or less';
    } else if (!validator.isInt(this.state.pw_expirationMonths, { min: 0 })) {
      message = 'Password expiration must be 0 or a positive integer';
    } else if (!validator.isInt(this.state.pw_expirationMonths, { max: 360 })) {
      message = 'Password expiration must be 360 or less';
    } else if (!validator.isInt(this.state.pw_attemptsBeforeLockout, { min: 0 })) {
      message = 'Attempts before lockout must be 0 or a positive integer';
    } else if (!validator.isInt(this.state.pw_attemptsBeforeLockout, { max: 25 })) {
      message = 'Attempts before lockout must be 25 or less';
    } else if (!validator.isInt(this.state.pw_historyReuseFrequency, { min: 0 })) {
      message = 'Password changes before reuse must be 0 or a positive integer';
    } else if (!validator.isInt(this.state.pw_historyReuseFrequency, { max: 5 })) {
      message = 'Password changes before reuse must be 5 or less';
    }
    if (message) {
      this.props.showMessageBox({
        title: 'Invalid Entry',
        message,
      });
      return false;
    }
    return true;
  }

  handleSubmit(e) {
    if (this.validate()) {
      let enterpriseData = {
        ...this.state.entDetail,
        enterpriseName: this.state.enterpriseName.trim(),
        adminEmail: this.state.adminEmail,
        enterpriseColor: this.state.enterpriseColor.split('#')[1],
        canUseVision: this.state.canUseVision,
        canUseBroadcast: this.state.canUseBroadcast,
        isActive: this.state.isActive,
        autoApprove: this.state.autoApprove,
        secureImages: this.state.secureImages,
        primaryContactName: this.state.primaryContactName,
        primaryContactPhone: this.state.primaryContactPhone,
        primaryContactEmail: this.state.primaryContactEmail,
        secondaryContactName: this.state.secondaryContactName,
        secondaryContactPhone: this.state.secondaryContactPhone,
        secondaryContactEmail: this.state.secondaryContactEmail,
        defaultRoleGUID: this.state.defaultRoleGUID,
        enterpriseTypeCode: parseInt(this.state.enterpriseTypeCode, 10),
        canHaveExtendedTribes: this.state.canHaveExtendedTribes,
        requireTerms: this.state.requireTerms,
        requireServiceAgreement: this.state.requireServiceAgreement,
        isSCF: this.state.isSCF,
        sessionTimeoutMinutes: parseInt(this.state.sessionTimeoutMinutes, 10),
        pw_minLength: this.state.isSCF && this.props.method !== 'edit' ? '8' : this.state.pw_minLength,
        pw_expirationMonths: this.state.pw_expirationMonths,
        pw_attemptsBeforeLockout: this.state.pw_attemptsBeforeLockout,
        pw_historyReuseFrequency: this.state.pw_historyReuseFrequency,
        pw_enforceComplexity: this.state.pw_enforceComplexity,
        language: this.state.language,
        countryISOCode: this.state.countryISOCode,
        currency: this.props.method !== 'edit' ? this.getCurrency(this.state.countryISOCode) : this.state.entDetail.currency
      }

      if (this.props.method === 'edit') {
        enterpriseData = {
          ...enterpriseData,
          adminEmail: null,
          defaultRoleGUID: this.state.defaultRoleGUID,
          enterpriseGUID: this.state.enterpriseGUID,
        }
      }

      if (this.props.method === 'add') {
        e.preventDefault();
        this.props.isLoading(true);
        v2Api.fetch('User/CheckForDuplicateUser', { userEmailAddress: enterpriseData.adminEmail.trim() })
          .then(({ data }) => {
            this.props.isLoading(false);
            if (data.hasDuplicate) {
              this.props.showMessageBox({ title: 'Invalid Entry', message: 'The admin email provided already exists in another enterprise' });
            } else {
              this.props.addEnterprise(enterpriseData);
              this.setState({
                redirect: true,
              });
            }
          })
          .catch(() => this.props.thereWasAnError());
      } else {
        this.props.updateEnterpriseInfo(enterpriseData);
      }
    } else {
      e.preventDefault();
    }
  }

  getCurrency(countryISOCode) {
    switch (countryISOCode) {
      case 'AU':
        return 'AUD';
      case 'BE':
        return 'EUR';
      case 'CA':
        return 'CAD';
      case 'DK':
        return 'DKK';
      case 'FR':
        return 'EUR';
      case 'DE':
        return 'EUR';
      case 'JP':
        return 'JPY';
      case 'GB':
        return 'GBP';
      case 'US':
        return 'USD';
      default:
        return 'USD';
    }
  }

  duplicateAdminAsPrimary() {
    if (this.props.method === 'add' && !this.state.primaryContactEmail.length) {
      this.setState({ primaryContactEmail: this.state.adminEmail });
    }
  }

  addDomain(save = false) {
    if (save) {
      let message;
      const domainToWhitelist = this.state.domainToWhitelist.trim();

      if (!domainToWhitelist.length) {
        message = 'Please provide a domain to whitelist';
      } else if (!validator.isFQDN(domainToWhitelist)) {
        message = 'The domain provided wasn\'t valid';
      } else if (this.props.enterpriseDetail.EnterpriseDomains.filter(domain => domain.enterpriseDomain === domainToWhitelist).length) {
        message = 'The domain provided is already whitelisted';
      }

      if (message) {
        this.props.showMessageBox({
          title: 'Invalid Entry',
          message,
        });
        return;
      }

      this.setState({
        isAddingDomain: false,
      });

      this.props.updateEnterpriseDomains(this.props.enterpriseGUID, this.state.domainToWhitelist);
      return;
    }
    this.setState({
      isAddingDomain: true,
      domainToWhitelist: '',
    });
  }

  deleteDomain(enterpriseDomain, enterpriseDomainID) {
    if (enterpriseDomain === false) {
      this.props.deleteEnterpriseDomain(this.props.enterpriseGUID, this.state.domainToDelete);
      this.setState({
        question: null,
        domainToDelete: null,
      });
      return;
    }
    this.setState({
      question: `Are you sure you want to delete the whitelisted domain ${enterpriseDomain}`,
      domainToDelete: enterpriseDomainID,
    })
  }

  resetDeleteDomain() {
    this.setState({
      question: null,
      domainToDelete: null,
    });
  }

  clickOutsideColorPicker() {
    this.toggleColorPicker();
  }

  clickOnColorPicker(e) {
    e.stopPropagation();
  }

  toggleColorPicker(e) {
    if (e && e.keyCode && e.keyCode !== 27) {
      // if it was a keypress but wasn't ESC
      return;
    }
    const willBeVisible = !this.state.showColorPicker;
    this.setState({
      showColorPicker: willBeVisible,
    });
    if (willBeVisible) {
      document.addEventListener('keydown', this.toggleColorPicker, false);
    } else {
      document.removeEventListener('keydown', this.toggleColorPicker, false);
    }
  }

  handleColorPickerChange(color) {
    this.setState({
      enterpriseColor: color.hex,
    });
  }

  handleColorTextClick() {
    if (!this.state.showColorPicker) {
      this.toggleColorPicker();
    }
  }

  handleColorTextKeyDown(e) {
    if (this.state.showColorPicker && e.keyCode === 13) {
      this.toggleColorPicker();
    }
  }

  handleColorTextChange(e) {
    const previousColor = this.state.enterpriseColor
    let color = e.target.value;
    if (color.length && color[0] !== '#') {
      color = `#${color}`;
    }
    if (color.length > 7) {
      this.setState({
        enterpriseColor: previousColor,
      });
      return;
    }
    this.setState({
      enterpriseColor: color,
    })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/admin/enterprise-maintenance/enterprises' />
    }

    const {
      method,
      enterpriseDetail,
      enterpriseGUID,
    } = this.props;

    const isLandLog = this.state.ssoProviderID == SSOProviderIDEnum.SSO_LANDLOG;

    if (this.state.question) {
      return (
        <QuestionBox
          title='Delete Whitelisted Domain?'
          yesCallback={() => this.deleteDomain(false)}
          noCallback={this.resetDeleteDomain}
        >
          {this.state.question}
        </QuestionBox>
      );
    }

    if (this.state.isAddingDomain) {
      return (
        <Dialog
          title='Add Whitelisted Domain'
          yesText='Save'
          yesCallback={() => this.addDomain(true)}
          noCallback={() => this.setState({ isAddingDomain: false })}
          backTo={`/admin/enterprise-maintenance/enterprises/${enterpriseGUID}/${method}`}
        >
          <div>
            <section className='section'>
              <div className='row'>
                <div className='col-xs-12 form-group'>
                  <label className='text-primary' htmlFor='domainToWhitelist'>Whitelist the following domain:</label>
                  <input
                    autoFocus={this.state.isAddingDomain}
                    className='form-control dark-label'
                    value={this.state.domainToWhitelist}
                    name='domainToWhitelist'
                    onChange={this.handleChange}
                    placeholder='somedomain.com'
                  />
                </div>
              </div>
            </section>
          </div>
        </Dialog>
      );
    }

    let status = 'New';
    if (method === 'edit') {
      status = enterpriseDetail.isActive ? 'Active' : 'Inactive';
    }

    const enterpriseTypeOptions = enterpriseTypes.map((type, i) => (
      <option value={type.code} key={i}>{type.name}</option>
    ));

    const enterpriseLanguageOptions = enterpriseLanguages.map((type, i) => (
      <option value={type.code} key={i}>{type.name}</option>
    ));

    const enterpriseCountryOptions = enterpriseCountries.map((type, i) => (
      <option value={type.code} key={i}>{type.country}</option>
    ));

    const roleOptions = enterpriseDetail.__Roles ? enterpriseDetail.__Roles.map((role, i) => (
      <option value={role.roleGUID} key={i}>{role.roleName}</option>
    )) : [];

    const colorSwatchStyle = this.state.enterpriseColor.length === 4 || this.state.enterpriseColor.length === 7 ?
      { backgroundColor: this.state.enterpriseColor } : {};

    const colorPickerClass = cx({
      'color-picker': true,
      'hidden': !this.state.showColorPicker,
    });

    const colorSwatchClass = cx({
      'color-swatch': true,
      'no-color': this.state.enterpriseColor.length !== 4 && this.state.enterpriseColor.length !== 7,
    });

    const adminEmailClass = cx({
      'row': true,
      'hidden': this.props.method === 'edit',
    });

    const whitelistClass = cx({
      'row': true,
      'hidden': this.props.method === 'add',
    });

    const defaultRoleClass = cx({
      'col-xs-12 form-group': true,
      'hidden': this.props.method === 'add',
    });

    const whitelistedDomains = enterpriseDetail.EnterpriseDomains ? enterpriseDetail.EnterpriseDomains.map((domain, i) => (
      <li className='whitelisted-domains__item' key={i}>
        <span className='whitelisted-domains__name'>{domain.enterpriseDomain}</span>
        <i className='fa fa-trash pull-right whitelisted-domains__delete' onClick={() => this.deleteDomain(domain.enterpriseDomain, domain.enterpriseDomainID)} />
      </li>
    )) : [];

    const formGroupStyle = { padding: '0 12px 0 6px' };

    return (
      <Dialog
        size='lg'
        title={method === 'edit' ? 'Edit Enterprise' : 'Add Enterprise'}
        backTo='/admin/enterprise-maintenance/enterprises'
        yesText='Save'
        yesCallback={this.handleSubmit}
        noCallback={(e) => {
          if (this.checkForDirty.test(e, this.state)) {
            e.preventDefault();
            this.props.setQuestion({
              title: 'Unsaved Changes',
              message: 'You have unsaved changes. Are you sure you want to leave this page?',
              yesCallback: () => this.props.history.push('/admin/enterprise-maintenance/enterprises'),
            });
          }
        }}
      >
        <div onClick={this.state.showColorPicker ? () => this.clickOutsideColorPicker() : () => { }}>
          <section className='section'>
            <div className='row'>
              <div className='col-xs-7'>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtStatus'>Status</label>
                    {method === 'add' ?
                      <input value={status} className='form-control dark-label' name='AddUser_txtStatus' disabled />
                      :
                      <select className='form-control' name='isActive' onChange={this.handleChange} value={this.state.isActive}>
                        <option value={true}>Active</option>
                        <option value={false}>Disabled</option>
                      </select>
                    }
                  </div>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtUsername'>Enterprise name*</label>
                    <input value={this.state.enterpriseName} disabled={isLandLog} onChange={this.handleChange} className='form-control dark-label' name='enterpriseName' maxLength='255' />
                  </div>
                </div>
                <div className={adminEmailClass}>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtFirstName'>Admin email*</label>
                    <input value={this.state.adminEmail} onBlur={this.duplicateAdminAsPrimary} onChange={this.handleChange} className='form-control dark-label' name='adminEmail' maxLength='255' />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='sessionTimeoutMinutes'>Session timeout in minutes (enter 0 for never)*</label>
                    <input value={this.state.sessionTimeoutMinutes} onChange={this.handleChange} className='form-control dark-label' name='sessionTimeoutMinutes' maxLength='255' />
                  </div>
                </div>
                <div className='panel panel-default'>
                  <div className='panel-heading'>Options</div>
                  <div className='panel-body'>
                    <div className='row'>
                      { /* <div className='col-xs-6 form-group'>
                          <div className='moo-form-element'>
                            <input name='canUseBroadcast' id='canUseBroadcast' type='checkbox' checked={this.state.canUseBroadcast} onChange={this.handleCheckboxToggle} />
                            <label htmlFor='canUseBroadcast'>Broadcast</label>
                          </div>
                        </div>
                        <div className='col-xs-6 form-group'>
                          <div className='moo-form-element'>
                            <input name='secureImages' id='secureImages' type='checkbox' checked={this.state.secureImages} onChange={this.handleCheckboxToggle} />
                            <label htmlFor='secureImages'>Secure images</label>
                          </div>
                        </div> */ }
                      <div className='col-xs-6 form-group'>
                        <div className='moo-form-element'>
                          <input name='autoApprove' id='autoApprove' type='checkbox' checked={this.state.autoApprove} onChange={this.handleCheckboxToggle} />
                          <label htmlFor='autoApprove'>AutoPublish</label>
                        </div>
                      </div>
                      <div className='col-xs-6 form-group'>
                        <div className='moo-form-element'>
                          <input name='canHaveExtendedTribes' id='canHaveExtendedTribes' type='checkbox' checked={this.state.canHaveExtendedTribes} onChange={this.handleCheckboxToggle} />
                          <label htmlFor='canHaveExtendedTribes'>Extended teams</label>
                        </div>
                      </div>
                      <div className='col-xs-6 form-group'>
                        <div className='moo-form-element'>
                          <input name='requireTerms' id='requireTerms' type='checkbox' checked={this.state.requireTerms} onChange={this.handleCheckboxToggle} />
                          <label htmlFor='requireTerms'>Require Terms</label>
                          <br></br>
                          <label htmlFor='requireTerms' className='wrappedLabelText'>of Use</label>
                        </div>
                      </div>
                      <div className='col-xs-6 form-group'>
                        <div className='moo-form-element'>
                          <input name='requireServiceAgreement' id='requireServiceAgreement' type='checkbox' checked={this.state.requireServiceAgreement} onChange={this.handleCheckboxToggle} />
                          <label htmlFor='requireServiceAgreement'>Require Service</label>
                          <br></br>
                          <label htmlFor='requireServiceAgreement' className='wrappedLabelText'>Agreement</label>
                        </div>
                      </div>
                      <div className='col-xs-6 form-group'>
                        <div className='moo-form-element'>
                          <input name='isSCF' id='isSCF' type='checkbox' checked={this.state.isSCF} onChange={this.handleCheckboxToggle} />
                          <label htmlFor='isSCF'>SCField</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {this.state.isSCF ? (
                  <div className='panel panel-default'>
                    <div className='panel-heading'>Country / Language</div>
                    <div className='panel-body'>
                      <div className='row'>
                        <div className='col-xs-12 form-group'>
                          <label className='text-primary' htmlFor='countryISOCode'>Country*</label>
                          <select className='form-control' name='countryISOCode' onChange={this.handleChange} value={this.state.countryISOCode}>
                            <option value={0}>Select...</option>
                            {enterpriseCountryOptions}
                          </select>
                        </div>
                        <div className='col-xs-12 form-group'>
                          <label className='text-primary' htmlFor='language'>Language*</label>
                          <select className='form-control' name='language' onChange={this.handleChange} value={this.state.language}>
                            <option value={0}>Select...</option>
                            {enterpriseLanguageOptions}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                ) :

                  <div className='panel panel-default'>
                    <div className='panel-heading'>Security (0 to disable)</div>
                    <div className='panel-body'>
                      <div className='row'>
                        <div className='col-xs-6 form-group' style={formGroupStyle}>
                          <label className='text-primary' htmlFor='pw_minLength'>Minimum password length*</label>
                          <input value={this.state.pw_minLength} onChange={this.handleChange} className='form-control dark-label' name='pw_minLength' maxLength='255' />
                        </div>
                        <div className='col-xs-6 form-group' style={formGroupStyle}>
                          <label className='text-primary' htmlFor='pw_expirationMonths'>Password expiration (months)*</label>
                          <input value={this.state.pw_expirationMonths} onChange={this.handleChange} className='form-control dark-label' name='pw_expirationMonths' maxLength='255' />
                        </div>
                        <div className='col-xs-6 form-group' style={formGroupStyle}>
                          <label className='text-primary' htmlFor='pw_attemptsBeforeLockout'>Password attempts before lockout*</label>
                          <input value={this.state.pw_attemptsBeforeLockout} onChange={this.handleChange} className='form-control dark-label' name='pw_attemptsBeforeLockout' maxLength='255' />
                        </div>
                        <div className='col-xs-6 form-group' style={formGroupStyle}>
                          <label className='text-primary' htmlFor='pw_historyReuseFrequency'>Password changes required before reuse*</label>
                          <input value={this.state.pw_historyReuseFrequency} onChange={this.handleChange} className='form-control dark-label' name='pw_historyReuseFrequency' maxLength='255' />
                        </div>
                        <div className='col-xs-12 form-group'>
                          <div className='moo-form-element'>
                            <input name='pw_enforceComplexity' id='pw_enforceComplexity' type='checkbox' checked={this.state.pw_enforceComplexity} onChange={this.handleCheckboxToggle} />
                            <label htmlFor='pw_enforceComplexity'>Require password complexity</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}

                <div className={whitelistClass} style={{ marginTop: 48 }}>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtPermissions'>
                      Whitelisted domains
                    </label>
                    <span className='whitelisted-domains__add pull-right' onClick={() => this.addDomain(false)}>Add +</span>
                    <div
                      className='panel inverse panel-primary whitelisted-domains__container'
                      style={{
                        minHeight: 277,
                        height: 277,
                      }}
                    >
                      <div className='panel-body'>
                        <ul className='list-group whitelisted-domains'>
                          {whitelistedDomains}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-xs-5'>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='enterpriseTypeCode'>Enterprise type*</label>
                    <select className='form-control' name='enterpriseTypeCode' onChange={this.handleChange} value={this.state.enterpriseTypeCode}>
                      <option value={0}>Select...</option>
                      {enterpriseTypeOptions}
                    </select>
                  </div>
                  <div className={defaultRoleClass}>
                    <label className='text-primary' htmlFor='defaultRoleGUID'>Default role*</label>
                    <select className='form-control' name='defaultRoleGUID' onChange={this.handleChange} value={this.state.defaultRoleGUID}>
                      <option value=''>Select...</option>
                      {roleOptions}
                    </select>
                  </div>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_selectRole'>Color*</label>
                    <div>
                      <div className={colorSwatchClass} style={colorSwatchStyle} onClick={this.toggleColorPicker}></div>
                      <input
                        placeholder='#8b91ff'
                        value={this.state.enterpriseColor}
                        onClick={this.handleColorTextClick}
                        onChange={this.handleColorTextChange}
                        onKeyDown={this.handleColorTextKeyDown}
                        className='form-control dark-label'
                        name='enterpriseColor'
                      />
                    </div>
                    <div className={colorPickerClass} onClick={(e) => this.clickOnColorPicker(e)}>
                      <SketchPicker
                        color={this.state.enterpriseColor}
                        onChangeComplete={this.handleColorPickerChange}
                        disableAlpha={true}
                        presetColors={[]}
                      />
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtUsername'>Primary contact</label>
                    <input value={this.state.primaryContactName} onChange={this.handleChange} className='form-control dark-label' name='primaryContactName' maxLength='255' />
                  </div>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtUsername'>Primary contact phone</label>
                    <input value={this.state.primaryContactPhone} onChange={this.handleChange} className='form-control dark-label' name='primaryContactPhone' maxLength='255' />
                  </div>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtUsername'>Primary contact email</label>
                    <input value={this.state.primaryContactEmail} onChange={this.handleChange} className='form-control dark-label' name='primaryContactEmail' maxLength='255' />
                  </div>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtUsername'>Secondary contact</label>
                    <input value={this.state.secondaryContactName} onChange={this.handleChange} className='form-control dark-label' name='secondaryContactName' maxLength='255' />
                  </div>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtUsername'>Secondary contact phone</label>
                    <input value={this.state.secondaryContactPhone} onChange={this.handleChange} className='form-control dark-label' name='secondaryContactPhone' maxLength='255' />
                  </div>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtUsername'>Secondary contact email</label>
                    <input value={this.state.secondaryContactEmail} onChange={this.handleChange} className='form-control dark-label' name='secondaryContactEmail' maxLength='255' />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Dialog>
    );
  }

}

export default AddEditEnterprise;



// WEBPACK FOOTER //
// ./src/components/Admin/AddEditEnterprise.js